import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { distinct, map, share } from 'rxjs/operators';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { ConfigService } from 'src/app/shared/config';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SvinnReportService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private config: ConfigService, private afs: AngularFirestore, private notifierService: NotificationService, private authService: AuthService) {

  }

  getSvinnRapport() {
    return this.afs.collection('svinn', ref => ref.orderBy('timestamp', 'desc')).get()
  }


  getAll(body) {
    // let dateFrom = moment(body['dateFrom']).unix()
    // let dateTo = moment(body['dateTo']).unix()
    // return this.systemService.transactionSiteRecord$(body['siteId'], dateFrom, dateTo)
    body = JSON.stringify(body);
    body = JSON.parse(body)
    delete body['focusBy']
    // console.log(moment.tz.names())
    return this.http.post(environment.apiUrl + "/widgets/svinnreport", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {

        // return res.map((item) => { return { ...item,project:item.project != null ? item.project.name: 'Not Assigned', freeText:item.freeText != null  ? item.freeText: '-'}});

        return res
      } else {
        return null
      }
    })).pipe(share());;
  }

  getSvinnByCompanyId(companyId: string, fromDateUnix: number, toDateUnix: number, category?: string, systemId?: string) {
    return this.afs.collection('svinn', ref => {
      let query = ref.where('companyId', '==', companyId).where('unix', '>=', fromDateUnix).where('unix', '<=', toDateUnix).orderBy('unix', 'desc');
      if (category) {
        query = query.where('name', '==', category);
      }
      if (systemId) {
        query = query.where('systemId', '==', systemId);
      }
      return query;
    }).get();
  }

  getTransactionsByCompanyId(companyId: string, fromDateUnix: number, toDateUnix: number, category?: string, systemId?: string) {
    return this.afs.collection('transactions', ref => {
      let query = ref.where('companyId', '==', companyId).where('unix', '>=', fromDateUnix).where('unix', '<=', toDateUnix).orderBy('unix', 'desc');
      if (category) {
        query = query.where('categories', 'array-contains', category);
      }
      if (systemId) {
        query = query.where('systemId', '==', systemId);
      }
      return query;
    }).get();
  }

  getSystemsByCompanyId(companyId: string) {
    return this.afs.collection('system_info', ref => ref.where('companyId', '==', companyId)).get();
  };

  svinnreportforsale(body) {
    // let dateFrom = moment(body['dateFrom']).unix()
    // let dateTo = moment(body['dateTo']).unix()
    // return this.systemService.transactionSiteRecord$(body['siteId'], dateFrom, dateTo)
    body = JSON.stringify(body);
    body = JSON.parse(body)
    delete body['focusBy']
    // console.log(moment.tz.names())
    return this.http.post(environment.apiUrl + "/widgets/svinnreportforsale", JSON.stringify(body), this.httpOptions).pipe(map(res => {

        return res
      
    })).pipe(share());;
  }

  
  getMappingByCompanyId(companyId: string) {
    return this.afs.collection('system_info', ref => ref.where('companyId', '==', companyId))
      .snapshotChanges()
      .pipe(map(data => {
        return data.map(doc => {
          const d = doc.payload.doc.data() as any;
          return {
            ...d,
            systemId: doc.payload.doc.id,
            name: d.name || doc.payload.doc.id,
            systemName: d.name || doc.payload.doc.id,
            selected: false,
          }

        })
      })).pipe(map(data => {
        return data.sort((a, b) => (a.systemName || '').localeCompare(b.systemName || ''));
      }));
  }



  getCategories(companyId: string) {
    return this.afs.collection('company').doc(companyId).collection('categories')
      .snapshotChanges()
      .pipe(map(data => {
        return data.map(doc => {
          return {
            name: doc.payload.doc.data()['name'],
            id: doc.payload.doc.id,
          }

        })
      }));
  }

}
